export default __webpack_public_path__ + "media/images/mailer/wordmark-a5dfe8214a1ed2f8f9353598f1f6b290.png";